import PropTypes from 'prop-types';
import { useSystemSetting } from '../context/SystemSettingContext';

export const Logo = (props) => {
  const { variant, style, showName = false, ...other } = props;
  const { setting } = useSystemSetting();

  const logoSrc = setting?.site_logo || "/images/logo.png";
  const siteName = setting?.site_name || "";

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', width: '100%' }}>
      <img
        src={logoSrc}
        alt={siteName || "Logo"}
        style={{
          height: '42px',
          width: 'auto',
          maxHeight: '42px',
          maxWidth: '180px',
          objectFit: 'contain',
          ...style
        }}
        onError={(e) => {
          e.target.src = "/images/logo.png";
        }}
        {...other}
      />
      {showName && siteName && (
        <span style={{ fontWeight: 'bold', fontSize: '18px', color: '#FFFFFF', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>
          {siteName}
        </span>
      )}
    </div>
  );
};

Logo.defaultProps = {
  variant: 'primary',
  showName: false
};

Logo.propTypes = {
  variant: PropTypes.oneOf(['light', 'primary']),
  showName: PropTypes.bool
};
